/**
 * 功能: slide元素的保存、删除、修改、以及ocr对图说的识别
 */

<template lang="pug">
  div.show-element(v-show = 'this.id')
    Region(ref="region" @add="handleAdd" @clear="handleClear" @revoke="handleRevoke" :imgUrl="imgUrl" :layers="elements" id="region" @changeImage="handleChangeImage")
    el-row(style="margin-top:20px;" )
      el-form(:inline="true" :size="GLOBAL.SIZE_OF_INPUTBOX" )
        el-form-item(label="主题")
          el-input(v-model="title" placeholder="请输入主题" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable style="width:200px" )
        el-form-item.fr
          el-button(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" style="margin-right:40px" @click="handleSave") 保存
    div(v-for="(element,index) in elements" :key="index")
      Element(ref="Elements" :index="index" :element="element" @deleteElement='deleteElement' :brief="brief" @getBase64="handleGetBase64" @updateOcrText="handleOcrText")
    el-backtop
    el-dialog(title="更改底图" :visible.sync="dialogVisible")
      el-upload(:action='GLOBAL.uploadHost+"slide/upload"'
        name="image"
        drag
        accept="image/jpeg,image/png"
        class="upload-demo"
        :headers="headers"
        :show-file-list="false"
        :multiple="false"
        :on-success="handleUploads")
        i(class="el-icon-upload")
        div(class="el-upload__text") 将文件拖到此处，或点击上传
      span(slot="footer" class="dialog-footer")
        el-button(@click="dialogVisible=false") 取消
    el-dialog(:visible.sync="ocrCanvasDialog" @close="handleCloseCanvas" destroy-on-close)
      el-row(v-loading="ocrLoading" element-loading-text="ocr识别中..." type="flex" justify="center")
        ocr-canvas(ref="ocrCanvas" @clickTextArea="handleClickTextArea")
      el-row(style="margin-top: 20px")
        el-button.fr(type="primary" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="ocrLoading" style="margin-right:10px" @click="handleSaveOCRJson") 保存
      edit-ocr-text(ref='editOcrText' @updateOcrText="handleUpdateOcrText" @deleteOcrText="handleDeleteOcrText" @reDrawCanvas="handleReDrawCanvas")
</template>

<script>
import Element from './components/element'
import Region from './region'
import Elements from '@/apis/elements'
import passport from '@/javascripts/passport'
import apiAttachment from '@/apis/attachment'
import apiImg from '@/apis/commuCore'
import EditOcrText from '@/views/report/components/contents/attachment/EditOcrText'
import OcrCanvas from '@/views/report/components/contents/attachment/OcrCanvas'

export default {
  components: { Region, Element, EditOcrText, OcrCanvas },
  props: {
    brief: Object
  },
  data () {
    return {
      headers: passport.headers(),

      id: '',
      title: '',
      elements: [],
      imgUrl: '',
      loImageUrl: '',
      hiImageUrl: '',
      originalImage: '',
      delElements: [],
      OCRJson: [],

      dialogVisible: false,
      ocrCanvasDialog: false,
      ocrLoading: false,
      currentIndex: -1
    }
  },
  methods: {
    // 关闭ocr识别，初始化数据
    handleCloseCanvas () {
      this.$refs.Elements[this.currentIndex].readLoading = false
      this.currentIndex = -1
      this.OCRJson = []
      this.ocrCanvasDialog = false
    },

    // 获取图片的base64字符串, 此处需要判断是识别表说的还是图说的
    handleGetBase64 (element) {
      const { attachment } = element
      this.currentIndex = element.index
      element = this.$refs.region.convertToNum(element, this.$refs.region.yImg.width, this.$refs.region.yImg.height)
      const imgBase64Str = this.getImagePortion(element.width, element.height, element.left, element.top)
      // 类型：0=图片，1=政策；
      if (attachment._class === 1) {
        this.handleTableOCR(imgBase64Str, this.currentIndex)
      } else if (attachment._class === 0) { // 调用图说方法
        this.handlIllOCR(imgBase64Str)
      }
    },

    // 将ocr识别的文字区域绘制到图片弹框上
    handleOcrText (element) {
      const { attachment } = element
      this.currentIndex = element.index
      element = this.$refs.region.convertToNum(element, this.$refs.region.yImg.width, this.$refs.region.yImg.height)
      const imgBase64Str = this.getImagePortion(element.width, element.height, element.left, element.top)
      this.ocrCanvasDialog = true
      this.$nextTick(() => {
        this.OCRJson = JSON.parse(attachment.OCRJson)
        this.$refs.ocrCanvas.drawCanvas(this.OCRJson, imgBase64Str)
      })
    },

    // 将图片绘制到canvas上并且返回base64
    getImagePortion (newWidth, newHeight, startX, startY) {
      var tnCanvas = document.createElement('canvas')
      var tnCanvasContext = tnCanvas.getContext('2d')
      tnCanvas.width = newWidth
      tnCanvas.height = newHeight
      tnCanvasContext.drawImage(this.$refs.region.yImg, startX, startY, newWidth, newHeight, 0, 0, newWidth, newHeight)
      return tnCanvas.toDataURL()
    },

    // 对表说执行ocr识别
    handleTableOCR (imgBase64Str, index) {
      Elements.tableOcr({ image: imgBase64Str }).then(r => {
        if (r.errCode === 0) {
          this.$refs.Elements[index].readTable(r.data)
        } else {
          this.$message.error('请重新选择表格区域')
        }
        this.$refs.Elements[index].readLoading = false
      })
    },

    // 对图说识别ocr
    handlIllOCR (imgBase64Str) {
      this.ocrCanvasDialog = true
      this.ocrLoading = true
      apiAttachment.ocr({ base64Str: imgBase64Str }).then(res => {
        this.ocrLoading = false
        if (res.errCode === 0) { // 画canvas
          this.OCRJson = res.data
          this.$refs.ocrCanvas.drawCanvas(res.data, imgBase64Str)
        } else {
          this.$message({ type: 'error', message: `ocr转码失败！${res.msg}` })
        }
      }).catch(err => {
        this.ocrLoading = false
        this.$message({ type: 'error', message: `ocr转码失败！${err}` })
      })
    },

    // 点击ocr识别的区域 并且弹框将数据显示
    handleClickTextArea () {
      this.$refs.editOcrText.show(this.OCRJson)
    },
    // 根据 ocr 识别的json数据 重新绘制ocr文字的区域
    handleReDrawCanvas (OCRJson) {
      this.$refs.ocrCanvas.reRenderOcrCanvas(OCRJson)
    },
    // 保存ocr文本
    handleUpdateOcrText (OCRJson) {
      this.OCRJson = OCRJson
    },
    // 删除ocr区域 并且重新绘制
    handleDeleteOcrText (OCRJson) {
      this.OCRJson = OCRJson
      this.$refs.ocrCanvas.reRenderOcrCanvas(this.OCRJson)
    },
    // 保存修改后的ocr JSON数据
    handleSaveOCRJson () {
      for (const item of this.OCRJson) {
        delete item.checked
        delete item.color
      }
      this.elements[this.currentIndex].attachment.OCRJson = JSON.stringify(this.OCRJson)
      this.elements[this.currentIndex].attachment.OCRText = (this.OCRJson.map(item => item.text)).join(',')
      this.ocrCanvasDialog = false
      this.$message({ type: 'success', message: '临时保存成功！' })
    },

    // 获取elements
    getElements (data) {
      this.$refs.region.clear('clear')
      if (!data) {
        this.imgUrl = ''
        this.id = ''
        return
      }
      this.imgUrl = data.image
      this.id = data.id
      this.$refs.region.reShow()
      Elements.getSlideById({ _id: data.id }).then(r => {
        if (r.errCode === 0) {
          this.elements = r.data.slide.elements
          this.title = r.data.slide.title
        }
      })
    },
    // 新增一行数据
    handleAdd (data) {
      const element = { ...data, title: '', text: '', attachment: { _class: -1, subObject: '', OCRJson: [] } }
      this.elements.push(element)
    },
    // 撤销绘制的区域
    handleRevoke () {
      this.elements.pop()
    },
    // 清空绘制的区域
    handleClear () {
      this.elements.splice(0, this.elements.length)
    },

    // 删除绘制的element元素
    deleteElement (i) {
      this.delElements.push(this.elements[i])
      this.elements.splice(i, 1)
      this.$refs.region.clear()
    },
    // 改变单个slide 显示弹框
    handleChangeImage () {
      this.dialogVisible = true
    },
    // 下载slide图片
    handleUploads (response) {
      apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + response.hiImageUrl).then(res => {
        this.imgUrl = window.URL.createObjectURL(res)
      })
      this.dialogVisible = false
      this.loImageUrl = response.loImageUrl
      this.hiImageUrl = response.hiImageUrl
    },
    // 保存element元素
    handleSave () {
      // 1. 校验数据合法性, 判断数据是否都已经关联
      const elements = []
      for (const element of this.elements) {
        const { _class } = element.attachment
        if (_class === -1) delete element.attachment.subObject // 文本
        if (_class !== 0) { // 非图说
          if (!element.attachment.subObject && _class !== -1) return this.$message({ message: '请关联附件', type: 'error' })
          delete element.attachment.source
          delete element.attachment.brandName
          delete element.attachment.brand
        } else { // 图说
          element.attachment.brand = element.attachment.brandName === '' ? null : element.attachment.brand
        }
        elements.push(element)
      }
      const slide = { _id: this.id, title: this.title, elements }
      if (this.loImageUrl !== '') {
        slide.loImageUrl = this.loImageUrl
        slide.hiImageUrl = this.hiImageUrl
      }
      Elements.saveSlide(slide).then(r => {
        if (r.errCode === 0) {
          this.elements.splice(0, this.elements.length, ...r.data.elements)
          if (!this.loImageUrl) this.$refs.region.clear()
          else this.$emit('changeImage', this.loImageUrl, this.hiImageUrl)
          this.$message({ message: '保存成功', type: 'success' })
        } else {
          this.$message({ message: '保存失败', type: 'warning' })
        }
      })
      // 如果当前关联附件只关联一个则执行删除操作
      if (this.delElements.length > 0) {
        for (const element of this.delElements) {
          if ([0, 1, 2].indexOf(element.attachment._class) > -1) {
            if (element._id && element.attachment.subObject) apiAttachment.delAttachment(element.attachment).then(res => { })
          }
        }
      }
    }
  }
}

</script>

<style scoped>
.show-element {
  flex: 10;
  margin: 10px 10px;
}
.upload-demo{
  display: flex;
  justify-content: center;
}
</style>
